import { colorBlue500, colorGray400 } from '@amzn/meridian-tokens/base/color';
import { css } from '@emotion/css';

import { ColorCodes } from '../constants/ColorCodes';

const { TURQUOISE_GREEN, LIGHT_GRAY } = ColorCodes;

export const profileStyle = css({
  height: '56px',
  border: 'none !important',
  backgroundColor: 'white !important',
  padding: 'none !important',
  margin: '0 !important',
  '&:hover': {
    boxShadow: 'none',
  },
});

export const profileMobileStyle = css({
  position: 'absolute',
  backgroundColor: 'white',
  zIndex: 52,
  top: '49px',
});

export const blackColor = css({
  color: '#000000 !important',
});

export const borderRadiusStyle = css({
  borderRadius: '8px',
});

export const imageStyle = css({
  borderRadius: '50%',
  color: 'white',
  fontWeight: 'bold',
});
export const imageStyleWithBorder = css({
  borderRadius: '50%',
  color: 'white',
  fontWeight: 'bold',
  border: '2px solid #18A395', 
  padding: '2px'
});

export const redColor = css({
  color: '#AF1F18 !important',
});

export const overlayWrapperStyle = css({
  position: 'fixed',
  top: '56px',
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 20,
});

export const modelContainerStyle = css({
  position: 'fixed',
  top: '63px',
  right: '7px',
  borderRadius: '5px',
  zIndex: 20,
  margin: '0 !important',
  height: 'calc(100% - 70px)',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarHeight: 'none',
  scrollbarWidth: 'none',
});

export const ellipsisStyle = css({
  whiteSpace: 'nowrap',
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const buttonPaddingStyle = css({
  padding: '0 8px !important',
});

export const headerShadow = css({
  boxShadow: '0px 2px 4px 0px #0B0C0C29',
  left: 0,
  right: 0,
  top: 0,
  position: 'sticky',
  zIndex: 52,
  height: '56px',
  backgroundColor: 'white',
});

export const borderLeftAndRightStyle = css({
  borderLeft: '1px solid #E7E9E9',
  borderRight: '1px solid #E7E9E9',
});

export const borderRightStyle = css({
  borderRight: '1px solid #E7E9E9',
});

export const profileBorderRadiusStyle = css({
  borderRadius: '5px',
});

export const heightStyle = css({
  height: '56px',
});

export const signOutIconStyle = css({
  color: '#077398',
});

export const italicStyle = css({
  fontStyle: 'italic',
});

export const turquoiseGreenStyle = css({
  color: TURQUOISE_GREEN,
});

export const grayColorStyle = css({
  color: colorGray400,
});

export const lightGrayStyle = css({
  color: `${LIGHT_GRAY} !important`,
});

export const mainStyle = css(`
overflow-y : auto !important
`);

export const iconBlueColorStyle = css({
  color: "#62EDE4",
});

export const sideMenuMargin = css({
  marginLeft: "-25px"
});

export const greyColorStyle = css({
  color: "#575F67",
});

export const newTagSpacing = css({
  padding: "2px 6px"
});

export const parentSideMenuColor = css({
  color: "#E7FAF6",
  ':hover': {
    color: "#E7FAF6",
  }
});

export const storeItemStyle = css({
  cursor: 'pointer',
});

export const circleIconStyle = css({
  width: '65px',
  //   height: '65px',
  background: ' #69b9ff',
  borderRadius: '70%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fontSize: '44px',
  margin: '2rem auto',
  aspectRatio: '1/1',
});

export const IconStyle = css({
  color: TURQUOISE_GREEN,
  paddingLeft: 'auto',
});

export const imageStyleTransform = css({
  borderRadius: '50%',
  color: 'white',
  fontWeight: 'bold',
});
